import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next({ name: "login" });
};

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next("/");
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "home",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () {
        return import("./views/Home.vue");
      },
      meta: { layout: "default" },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/login",
      name: "login",
      meta: { layout: "blank" },
      component: () => {
        return import("./views/Login.vue");
      },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/settings",
      name: "settings",
      meta: { layout: "default" },
      component: () => {
        return import("./views/Settings.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/profile",
      name: "profile",
      meta: { layout: "default" },
      component: () => {
        return import("./views/Profile.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/organization",
      name: "organization",
      meta: { layout: "default" },
      component: () => {
        return import("./views/Organization.vue");
      },
      beforeEnter: ifAuthenticated
    },

    {
      path: "/project",
      name: "project",
      meta: { layout: "grant" },
      component: () => {
        return import("./views/Project.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/reports",
      name: "reports",
      meta: { layout: "grant" },
      component: () => {
        return import("./views/Reports.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/reports/create",
      name: "createReport",
      meta: { layout: "grant" },
      component: () => {
        return import("./components/Report.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/resources",
      name: "resources",
      meta: { layout: "grant" },
      component: () => {
        return import("./views/Resources.vue");
      },
      beforeEnter: ifAuthenticated
    },

    {
      path: "/collection/:uuid",
      name: "collection",
      meta: { layout: "grant" },
      component: () => {
        return import("./views/Collection.vue");
      },
      beforeEnter: ifAuthenticated
    },
    {
      path: "/news",
      component: () => {
        return import("./views/News.vue");
      },
      children: [
        {
          path: '',
          name: "news",
          meta: { layout: "grant", breadCrumb: "Vesti" },
          component: () => {
            return import("./components/NewsTable.vue");
          },
        },
        {
          path: ':article_id',
          name: "edit_news",
          meta: { layout: "grant", breadCrumb: "Article" },
          component: () => {
            return import("./components/NewsForm.vue");
          },
        }
      ],
      beforeEnter: ifAuthenticated
    },
    {
      path: "/calendar",
      name: "calendar",
      meta: { layout: "grant" },
      component: () => {
        return import("./views/Calendar.vue");
      },
      beforeEnter: ifAuthenticated
    },

    {
      path: "/error",
      name: 'error',
      meta: { layout: "blank" },
      component: () => {
        return import("./views/ServerError.vue");
      }
    },

    {
      path: "*",
      meta: { layout: "blank" },
      component: () => {
        return import("./views/404.vue");
      }
    }
  ]
});

export default router;
